import { ArrowRight } from "lucide-react";
import { CONTACT_URL } from "@/lib/marketing";

export const CtaButtons = ({ prefix = "hero", dark = false }) => (
  <div className="flex flex-wrap items-center gap-3">
    <a href={CONTACT_URL} data-testid={`${prefix}-cta-pilot`}
       className={`inline-flex items-center gap-2 px-6 py-3 rounded-sm font-semibold transition-colors duration-200 ${dark ? "bg-white text-[#275C3F] hover:bg-[#EAF0EA]" : "bg-[#275C3F] text-white hover:bg-[#1E4731]"}`}>
      Request a paid pilot <ArrowRight className="h-4 w-4" />
    </a>
    <a href={CONTACT_URL} data-testid={`${prefix}-cta-evaluation`}
       className={`inline-flex items-center gap-2 px-6 py-3 rounded-sm font-semibold border transition-colors duration-200 ${dark ? "border-white/30 text-white hover:bg-white/10" : "border-[#DCE3DD] bg-white hover:bg-[#EAF0EA]"}`}>
      Book a $1,500 compliance evaluation
    </a>
    <a href={CONTACT_URL} data-testid={`${prefix}-cta-safety-pro`}
       className={`text-sm font-semibold underline underline-offset-4 px-2 py-3 ${dark ? "text-white/90 hover:text-white" : "text-[#275C3F] hover:text-[#1E4731]"}`}>
      Talk to a safety pro
    </a>
  </div>
);
